import React from "react"
import { FormattedMessage } from "react-intl"
import { Box, Progress, Typography } from "@carrotfertility/carotene-core"

export const AirwallexPinUnavailable = () => (
  <Typography variant="body2" color="text.secondary">
    <FormattedMessage
      defaultMessage="PIN unavailable"
      description="Shown in place of a member's card PIN when Airwallex cannot return one"
    />
  </Typography>
)

export const AirwallexPinRow = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={(theme) => ({
      backgroundColor: theme.palette.success.light,
      paddingBlock: theme.spacing(theme.tokens.spacing.xs),
      paddingInline: theme.spacing(theme.tokens.spacing.xs),
      borderBlockStart: `${theme.tokens.borderWidth.sm} solid ${theme.palette.divider}`
    })}
  >
    <Typography
      component="span"
      variant="overline"
      color="text.secondary"
      sx={(theme) => ({
        display: "block",
        marginBlockEnd: theme.spacing(theme.tokens.spacing.xxxs)
      })}
    >
      <FormattedMessage defaultMessage="PIN" description="Label displayed above a member's card PIN" />
    </Typography>
    {children}
  </Box>
)

export const AirwallexPinValueLoading = () => (
  <Box
    sx={(theme) => ({
      alignItems: "center",
      display: "flex",
      minBlockSize: theme.spacing(theme.tokens.spacing.lg)
    })}
  >
    <Progress size="1rem" />
  </Box>
)
